'use client'

import type { ProductSize } from 'product/types/Product'
import type { ProductLocations } from 'product/types/ProductLocations'
import type { Stock, StockAvailability } from 'product/types/Stock'
import type { DelayedSize } from 'product-components/components/SizeSelector/hooks/useProductSelectedColorSizes/useProductSelectedColorSizes'
import { Size } from './Size/Size'
import styles from './SizesList.module.css'

export interface DelayedTime {
	zone: string
	deliveryTimeType: 'HOURS' | 'DAYS' | 'SAMEDAY'
	minimumTime: number
	maximumTime: number
	hoursTime: number
}

export interface SelectedSize {
	size: ProductSize & StockAvailability & DelayedSize
	color: string
}

export type SizeListProps = {
	selectedColorId: string
	selectedProductId: string
	location: ProductLocations
	sizes: (ProductSize & StockAvailability & DelayedSize)[]
	'data-testid'?: string
	onSelectedSize: (selectedSize: SelectedSize) => void
}

export interface SizeListExtended extends SizeListProps {
	delayedMessage?: string
	productStock?: Stock
	delayedWareHouse?: (warehousesIds?: string[]) => boolean
}

export function SizesList({
	selectedColorId,
	selectedProductId,
	sizes,
	onSelectedSize,
	...extended
}: Readonly<SizeListProps | SizeListExtended>) {
	const { delayedMessage, location } = extended as SizeListExtended

	return (
		<ol
			className={styles.list}
			data-testid={'product.sizesBottomSheet.sizesList'}
		>
			{sizes.map((size) => (
				<li key={size.id} className={styles.item}>
					<Size
						size={size}
						location={location}
						selectedColorId={selectedColorId}
						selectedProductId={selectedProductId}
						delayedMessage={delayedMessage}
						onSelectedSize={onSelectedSize}
					/>
				</li>
			))}
		</ol>
	)
}
